module.exports = require("@web3auth/metamask-adapter");